import { styled, Typography } from "@mui/material";

export const SelectionCountHeader = styled(Typography)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
`;
